/* VAEN v6 · Home scenes */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var ss = function (a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
  var scenes = [];
  function progress(el) { var r = el.getBoundingClientRect(), d = el.offsetHeight - innerHeight; return d > 0 ? clamp(-r.top / d, 0, 1) : (r.top < 0 ? 1 : 0); }
  function visible(el) { var r = el.getBoundingClientRect(); return r.bottom > -100 && r.top < innerHeight + 100; }

  /* ---------- hero ---------- */
  function hero(sec) {
    var ink = $('[data-h6h-ink]', sec), S = 72;
    function geo() {
      var vw = innerWidth, vh = sec.querySelector('.h6h__stage').offsetHeight, mob = vw < 750;
      var lw = mob ? vw * .9 : Math.min(vw * .88, 1500), lh = lw * 100 / 318;
      var lx = (vw - lw) / 2, ly = (vh - lh) * (mob ? .42 : .44);
      sec.style.setProperty('--ox', (lx + lw * 263.5 / 318).toFixed(1) + 'px');
      sec.style.setProperty('--oy', (ly + lh * .5).toFixed(1) + 'px');
      ink.style.setProperty('--ox', (lx + lw * 263.5 / 318).toFixed(1) + 'px');
      ink.style.setProperty('--oy', (ly + lh * .5).toFixed(1) + 'px');
      S = Math.max(60, 2.4 * Math.max(vw, vh) / (lw * 11 / 318));
    }
    geo(); addEventListener('resize', geo);
    return function () {
      if (!visible(sec)) return;
      var p = progress(sec), t = ss(.03, .6, p);
      var sc = Math.pow(S, t);
      ink.style.transform = 'scale(' + sc.toFixed(3) + ')';
      ink.style.visibility = t > .985 ? 'hidden' : 'visible';
      sec.style.setProperty('--io', (1 - ss(0, .1, p)).toFixed(3));
      sec.style.setProperty('--is', (1.2 - .2 * ss(.05, .85, p)).toFixed(4));
      var fo = ss(.6, .82, p);
      sec.style.setProperty('--fo', fo.toFixed(3));
      sec.style.setProperty('--p', p.toFixed(4));
      sec.classList.toggle('is-final', fo > .5);
    };
  }

  /* ---------- types (pinned horizontal, 3D) ---------- */
  function types(sec) {
    var track = $('[data-h6t-track]', sec), cards = $$('[data-h6t-card]', sec), prog = $('[data-h6t-prog]', sec), idx = $('[data-h6t-i]', sec);
    var dist = 0, desk = false;
    function geo() {
      desk = innerWidth >= 990;
      if (!desk) { sec.style.height = ''; track.style.transform = ''; cards.forEach(function (c) { c.style.removeProperty('--ry'); c.style.removeProperty('--tz'); }); return; }
      dist = Math.max(0, track.scrollWidth - innerWidth);
      sec.style.height = (dist + innerHeight * 1.15) + 'px';
    }
    geo(); addEventListener('resize', geo); addEventListener('load', geo);
    return function () {
      if (!desk || !visible(sec)) return;
      var p = progress(sec), x = dist * ss(0, 1, p) ;
      x = dist * p;
      track.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
      if (prog) prog.parentNode.style.setProperty('--p', p.toFixed(4));
      var cx = innerWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), d = ((r.left + r.width / 2) - cx) / cx;
        var ad = Math.abs(d); if (ad < bd) { bd = ad; best = i; }
        d = clamp(d, -1.4, 1.4);
        c.style.setProperty('--ry', (d * -16).toFixed(2) + 'deg');
        c.style.setProperty('--tz', (-Math.abs(d) * 110).toFixed(1) + 'px');
        c.style.setProperty('--px', (d * -5).toFixed(2) + '%');
      });
      if (idx) idx.textContent = ('0' + Math.min(best + 1, cards.length - 1)).slice(-2);
    };
  }
  window.VAEN6H = window.VAEN6H || {}; window.VAEN6H.types = types;

  /* ---------- layers ---------- */
  function layers(sec) {
    var iso = $('[data-h6l-iso]', sec), lys = $$('[data-h6l-ly]', sec), steps = $$('[data-h6l-step]', sec), dots = $$('[data-h6l-dot]', sec);
    var n = $('[data-h6l-n]', sec), prog = $('[data-h6l-prog]', sec), drops = $$('.h6l__drops i', sec), last = -1;
    return function () {
      if (!visible(sec)) return;
      var p = progress(sec), mob = innerWidth < 990;
      var ex = ss(.1, .48, p) * (1 - ss(.56, .7, p));
      var gmax = mob ? 16 : 34;
      iso.style.setProperty('--g', (1.5 + ex * (gmax - 1.5)).toFixed(2) + 'px');
      iso.style.setProperty('--rz', (-46 + p * 16).toFixed(2) + 'deg');
      var cnt = Math.round(ss(.1, .46, p) * 9);
      if (n) n.textContent = ('0' + cnt).slice(-2);
      lys.forEach(function (l, i) {
        var a = ss(.12 + i * .035, .18 + i * .035, p) * (1 - ss(.56, .64, p));
        l.style.setProperty('--lo', a.toFixed(3));
        l.style.opacity = (.15 + .85 * ss(.08 + i * .035, .14 + i * .035, p)).toFixed(3);
      });
      drops.forEach(function (d) {
        var o = parseFloat(d.style.getPropertyValue('--d')) || 0;
        var t = ss(.7 + o * .12, .8 + o * .12, p);
        d.style.setProperty('--dz', ((1 - t) * 420).toFixed(1) + 'px');
        d.style.setProperty('--ds', (.55 + t * .45 + ss(.8 + o * .12, .86 + o * .12, p) * .25).toFixed(3));
        d.style.setProperty('--do', ss(.66 + o * .12, .7 + o * .12, p).toFixed(3));
      });
      var st = p < .3 ? 0 : (p < .62 ? 1 : 2);
      if (st !== last) { last = st; steps.forEach(function (e, i) { e.classList.toggle('is-on', i === st); }); dots.forEach(function (e, i) { e.classList.toggle('is-on', i === st); }); }
      if (prog) prog.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
  }
  window.VAEN6H.layers = layers;

  /* ---------- origin ---------- */
  function origin(sec) {
    var coin = $('[data-h6o-coin]', sec), lines = $$('[data-h6o-l]', sec), counted = false;
    var nums = $$('[data-h6o-count]', sec).map(function (b) {
      var raw = b.getAttribute('data-h6o-count'), m = raw.match(/^(\D*)(\d+)(.*)$/);
      return m ? { el: b, pre: m[1], n: parseInt(m[2], 10), post: m[3] } : null;
    }).filter(Boolean);
    nums.forEach(function (o) { o.el.textContent = o.pre + '0' + o.post; });
    function count() {
      if (counted) return; counted = true; var t0 = performance.now();
      (function f(t) { var k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 3); nums.forEach(function (o) { o.el.textContent = o.pre + Math.round(o.n * e) + o.post; }); if (k < 1) requestAnimationFrame(f); })(t0);
    }
    return function () {
      if (!visible(sec)) return;
      var p = progress(sec), r = sec.getBoundingClientRect();
      var enter = clamp(1 - r.top / innerHeight, 0, 1);
      coin.style.setProperty('--cy', (-24 + (p * 0.85 + enter * .15) * 384).toFixed(2) + 'deg');
      coin.style.setProperty('--cx', (8 - p * 14).toFixed(2) + 'deg');
      lines.forEach(function (l) { var dir = parseFloat(l.getAttribute('data-h6o-l')); var w = l.scrollWidth / 3; l.style.transform = 'translate3d(' + (dir > 0 ? -(p * w) : (p * w - w)).toFixed(1) + 'px,0,0)'; });
      if (p > .02 || enter > .6) { sec.classList.add('is-in'); count(); }
    };
  }
  window.VAEN6H.origin = origin;

  function init() {
    if (reduce) return;
    $$('[data-h6-hero]').forEach(function (s) { if (!s.__h) { s.__h = 1; scenes.push(hero(s)); } });
    $$('[data-h6-types]').forEach(function (s) { if (!s.__h && window.VAEN6H && VAEN6H.types) { s.__h = 1; scenes.push(VAEN6H.types(s)); } });
    $$('[data-h6-layers]').forEach(function (s) { if (!s.__h && window.VAEN6H && VAEN6H.layers) { s.__h = 1; scenes.push(VAEN6H.layers(s)); } });
    $$('[data-h6-origin]').forEach(function (s) { if (!s.__h && window.VAEN6H && VAEN6H.origin) { s.__h = 1; scenes.push(VAEN6H.origin(s)); } });
    run();
  }
  var tick = false;
  function run() { tick = false; scenes.forEach(function (f) { f && f(); }); }
  addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener('resize', function () { requestAnimationFrame(run); });
  window.VAEN6H = window.VAEN6H || {};
  window.VAEN6H.util = { $: $, $$: $$, ss: ss, clamp: clamp, progress: progress, visible: visible };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
